// Globals
import { FC, useMemo, useRef } from 'react';
import { BaseSelectRef } from 'rc-select';
import { SelectProps } from 'antd';

// Modules
import { getFaqChannelsOptions } from '../../helpers';
import { useGetFaqChannels } from '../../hooks';

// Components
import { Select } from '@/ui';

type TFaqChannelsSelectProps = {
  onChange?: (channelId?: number) => void;
  value?: number | null;
  disabled?: boolean;
  allowClear?: boolean;
  placeholder?: string;
  size?: SelectProps['size'];
};

const FaqChannelsSelect: FC<TFaqChannelsSelectProps> = ({
  onChange,
  value,
  disabled,
  allowClear,
  placeholder,
  size,
}) => {
  const selectRef = useRef<BaseSelectRef>(null);
  const { channels, isLoading } = useGetFaqChannels();

  const options = useMemo(() => getFaqChannelsOptions(channels), [channels]);

  const handleSelect = () => selectRef.current?.blur();

  return (
    <Select
      ref={selectRef}
      showSearch
      loading={isLoading}
      options={options}
      value={value}
      onChange={onChange}
      onSelect={handleSelect}
      disabled={disabled}
      allowClear={allowClear}
      placeholder={placeholder}
      size={size}
    />
  );
};

export default FaqChannelsSelect;
